const CACHE_KEY = 'user_cache';
const CACHE_TIMESTAMP_KEY = 'user_cache_timestamp';
const CACHE_DURATION = 24 * 60 * 60 * 1000;

export function getUserFromCache() {
  const cachedUser = localStorage.getItem(CACHE_KEY);
  const cachedTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);

  if (cachedUser && cachedTimestamp) {
    const age = Date.now() - parseInt(cachedTimestamp, 10);
    if (age < CACHE_DURATION) {
      return JSON.parse(cachedUser);
    }
  }
  return null;
}

export function setUserToCache(user) {
  localStorage.setItem(CACHE_KEY, JSON.stringify(user));
  localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now().toString());
}

export function invalidateUserCache() {
  localStorage.removeItem(CACHE_KEY);
  localStorage.removeItem(CACHE_TIMESTAMP_KEY);
}
